import React from 'react'

import { Button, Select } from '@clientbase/clientbase-library'
import {
  MenuItem,
  SelectChangeEvent,
  Typography,
  useMediaQuery
} from '@mui/material'

import { OrderParams, OrderProps } from './Order.interface'
import * as S from './Order.styles'

export const Order: React.FC<OrderProps> = ({
  disableArrow = false,
  handleOnChange,
  options,
  value
}) => {
  function handleOnChangeLocal(
    order: OrderParams,
    event: SelectChangeEvent<unknown>
  ) {
    const {
      target: { value }
    } = event

    return handleOnChange(value as string, order)
  }

  const isMobile = useMediaQuery('(max-width: 600px)', { noSsr: false })

  function handleOnChangeSort() {
    const sort = value.sort
    if (sort === 'asc') {
      handleOnChange(String(value.label), 'desc')
    } else {
      handleOnChange(String(value.label), 'asc')
    }
  }

  return (
    <S.Wrapper>
      {value.label !== 'initial' && !disableArrow && (
        <Button
          onClick={handleOnChangeSort}
          style={{ marginRight: '8px' }}
          variantButton="neutral"
          startIcon={value.sort === 'asc' ? 'arrowUpward' : 'arrowDownward'}
        />
      )}

      <S.SelectWrapper sx={{ width: isMobile ? '100%' : 'auto' }}>
        <Select
          sx={{ border: 0, '*': { border: 0, outline: 0 } }}
          fullWidth
          onChange={(event: SelectChangeEvent<unknown>) =>
            handleOnChangeLocal(value.sort, event)
          }
          value={value.label}
          renderValue={(value) => {
            const option = options.find(
              (opt) => opt.value == (value as unknown as string)
            )?.label

            return <Typography variant="smBold">{option}</Typography>
          }}
        >
          {options.map(({ label, value }, index) => (
            <MenuItem key={index} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </S.SelectWrapper>
    </S.Wrapper>
  )
}
